import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Download, Loader2 } from "lucide-react";
import { TEAMS } from "@/lib/teams";

const today = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

export function StaffActivity({ staff }) {
    const [date, setDate] = useState(today);
    const [team, setTeam] = useState("");
    const [sid, setSid] = useState("");
    const [data, setData] = useState(null);
    const qs = `date=${date}${team ? `&team=${team}` : ""}${sid ? `&staff_id=${sid}` : ""}`;
    useEffect(() => { setData(null); api.get(`/admin/staff/activity?${qs}`).then((r) => setData(r.data)).catch(() => setData({ rows: [], summary: [] })); }, [qs]);
    const sel = "rounded-full border border-navy/15 bg-white px-3 py-2 text-xs font-bold text-navy";
    return (
        <div data-testid="staff-activity" className="space-y-4">
            <div className="flex flex-wrap items-center gap-2">
                <input data-testid="activity-date" type="date" value={date} max={today()} onChange={(e) => setDate(e.target.value || today())} className={sel} />
                <select data-testid="activity-team" value={team} onChange={(e) => { setTeam(e.target.value); setSid(""); }} className={sel}><option value="">All teams</option>{Object.entries(TEAMS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
                <select data-testid="activity-staff" value={sid} onChange={(e) => setSid(e.target.value)} className={sel}><option value="">All staff</option>{staff.filter((s) => !team || s.team === team).map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}</select>
                <a data-testid="activity-csv" href={`${API}/admin/staff/activity?${qs}&format=csv`} className="ml-auto flex items-center gap-1 rounded-full bg-navy px-4 py-2 text-xs font-bold text-white"><Download size={13} /> Download CSV</a>
            </div>
            {!data ? <div className="flex justify-center py-12"><Loader2 className="h-6 w-6 animate-spin text-orange" /></div> : (
                <>
                    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                        {data.summary.map((s) => (
                            <div key={s.staff_id} data-testid={`activity-summary-${s.staff_id}`} className="rounded-2xl border border-navy/10 bg-white p-4">
                                <p className="font-heading font-bold text-navy">{s.staff_name} <span className="text-xs font-semibold text-navy/45">· {TEAMS[s.team] || s.team}</span></p>
                                <p className="mt-1 font-heading text-2xl font-extrabold text-orange">{s.changes} <span className="text-xs font-semibold text-navy/45">changes</span></p>
                                <p className="text-[11px] text-navy/55">First {s.first} · Last {s.last}</p>
                                <p className="mt-1 text-[11px] text-navy/60">{s.top_actions.map(([a, n]) => `${a} ×${n}`).join(" · ") || "Signed in only"}</p>
                            </div>
                        ))}
                    </div>
                    <div className="overflow-x-auto rounded-2xl border border-navy/10 bg-white homiie-scroll">
                        <table className="w-full text-sm" data-testid="activity-table">
                            <thead className="bg-navy/[0.03] text-left text-xs uppercase tracking-wide text-navy/50"><tr>{["Time", "Staff", "Team", "Action", "Booking"].map((h) => <th key={h} className="px-4 py-3">{h}</th>)}</tr></thead>
                            <tbody>
                                {data.rows.map((r) => (
                                    <tr key={r.id} className="border-t border-navy/5">
                                        <td className="whitespace-nowrap px-4 py-2.5 text-navy/60">{r.time}</td>
                                        <td className="px-4 py-2.5 font-semibold text-navy">{r.staff_name}</td>
                                        <td className="px-4 py-2.5 text-navy/60">{TEAMS[r.team] || r.team}</td>
                                        <td className="px-4 py-2.5 text-navy">{r.action}</td>
                                        <td className="px-4 py-2.5 text-navy/60">{r.ref || "—"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {!data.rows.length && <div className="py-12 text-center text-sm text-navy/40">No staff activity on this day.</div>}
                    </div>
                </>
            )}
        </div>
    );
}
